module.exports = __webpack_public_path__ + "img/arrow_right.1ff10d95.png";